import { Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";

type TLoadingSpinnerProps = {
  /** Size variant */
  size?: "xs" | "sm" | "md" | "lg";
  /** Color variant */
  color?: "gray" | "primary" | "white";
  /** Optional className for the wrapper */
  className?: string;
};

const sizeClasses = {
  xs: "h-4 w-4",
  sm: "h-3.5 w-3.5 sm:h-4 sm:w-4",
  md: "h-5 w-5 sm:h-6 sm:w-6",
  lg: "h-8 w-8 sm:h-10 sm:w-10",
};

const colorClasses = {
  gray: "text-muted-foreground",
  primary: "text-primary",
  white: "text-white",
};

export function LoadingSpinner({ size = "md", color = "gray", className }: TLoadingSpinnerProps) {
  return (
    <Loader2
      className={cn("animate-spin", sizeClasses[size], colorClasses[color], className)}
      aria-hidden
    />
  );
}
